import { getLoginCookieData } from "../util";

export const getAgreementId = (): number | null => {
  return getLoginCookieData()?.agreementId ?? null;
};
